var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editing-access"},[_c('h2',{staticClass:"mb-2 text-lg font-semibold uppercase text-gray-800"},[_vm._v("Access")]),_c('el-switch',{attrs:{"active-text":"공용","inactive-text":"개인용"},model:{value:(_vm.shared),callback:function ($$v) {_vm.shared=$$v},expression:"shared"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }